// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BranchesOutlinedSvg from "@fishx/icons-svg/es/asn/BranchesOutlined";
import FishxIcon from '../components/FishxIcon';

var BranchesOutlined = function BranchesOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BranchesOutlinedSvg
  }));
};

BranchesOutlined.displayName = 'BranchesOutlined';
export default React.forwardRef(BranchesOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BranchesOutlined.js
// module id = 2113
// module chunks = 0